import { CookiesStorageService } from '@/services';

const marketingCookiePrefixes = [
	// Google Analytics
	'_ga',
	'_gid',
	'_gat',

	// Google Ads / DoubleClick
	'_gcl_au',
	'_gcl_aw',
	'_gcl_dc',
	'_gac',
	'IDE',
	'test_cookie',
	'NID',
	'1P_JAR',
	'ANID',
	'CONSENT',

	// Facebook
	'_fbp',
	'_fbc',
	'tr',

	// TikTok
	'_ttp',
	'_tt_enable_cookie',
	'tt_appInfo',
	'tt_pixel_session_index',
	'tt_sessionId',

	// Microsoft Ads / Bing
	'_uetmsclkid',
	'_uetsid',
	'_uetvid',
	'MUID',
];

const preservedCookiePrefixes = ['amp_', 'amplitude_', 'AMP_'];

export const removeMarketingCookies = () => {
	const cookieList = CookiesStorageService.getAll();
	Object.keys(cookieList).forEach(cookieName => {
		const isPreserved = preservedCookiePrefixes.some(prefix =>
			cookieName.startsWith(prefix),
		);
		if (isPreserved) return;

		const isMarketingCookie = marketingCookiePrefixes.some(
			prefix => cookieName === prefix || cookieName.startsWith(prefix),
		);
		if (isMarketingCookie) {
			CookiesStorageService.removeFromAllDomains(cookieName);
		}
	});
};
